<template>
  <MessageLayout :is-archived="isArchived" :message="message">
    <!-- eslint-disable vue/no-v-html -->
    <h6
      slot="header"
      class="message__title"
      v-html="highlightText(
        message.data.rejection_reason,
        message.data.highlighted_rejection_reason,
        paletteFidmarques.red
      )"
    />
    <!-- eslint-enable vue/no-v-html -->

    <!-- eslint-disable vue/no-v-html -->
    <div v-if="message.data.text" slot="content" class="message__text" v-html="nl2br(message.data.text)" />
    <!-- eslint-enable vue/no-v-html -->

    <div v-if="message.data.receipt_image_url" slot="footer">
      <ButtonV3
        text="Voir le ticket"
        text-uppercase
        :color="paletteFidmarques.yellow"
        bg-color="white"
        :border-color="paletteFidmarques.yellow"
        @click="showModalImage(message.data.receipt_image_url)"
      />
    </div>
  </MessageLayout>
</template>

<script>
import { mapActions } from 'vuex'

import Mixin from './mixin'

import ButtonV3 from '../../../elements/ButtonV3'

export default {
  components: { ButtonV3 },
  mixins: [Mixin],
  props: {
    message: {
      type: Object,
      required: true,
      validator: message =>
        message.hasOwnProperty('data') &&
        message.data.hasOwnProperty('rejection_reason') &&
        message.data.hasOwnProperty('highlighted_rejection_reason') &&
        message.data.hasOwnProperty('receipt_image_url') &&
        true
      ,
    },
  },
  methods: {
    ...mapActions('timeline', ['showModalImage']),

    highlightText (text, highlighted, color) {
      return text.replace(highlighted, `<span style="color: ${color};">${highlighted}</span>`)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~assets/css/mixins";

.message__title {
  // @include font-family__oswald;
  margin: 0;
}
.message__text {
  padding: 1rem;
}
</style>
